import { initComponent } from './core/init-component.js'
import { Swiper } from 'swiper'
import { Navigation } from 'swiper/modules'

initComponent('.js-pdp-story', section => {
  const slider = section.querySelector('.js-story-swiper')
  const prevEl = section.querySelector('.js-slider-prev')
  const nextEl = section.querySelector('.js-slider-next')
  const slidesCount = section.querySelectorAll('.js-slide').length

  const swiper = new Swiper(slider, {
    modules: [Navigation],
    slidesPerView: 1.05,
    spaceBetween: 8,
    slidesPerGroup: 1,
    freeMode: false,
    navigation: {
      prevEl,
      nextEl
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
      }
    }
  })

  return {
    unload() {
      swiper.destroy()
    }
  }
})
